/**
 * Copyright 2020 (c) Dominik Basner, Sotec GmbH (for VDW e.V.)
 * Copyright 2020 (c) Fabian Wilhelm, Sotec GmbH (for VDW e.V.)
 * Copyright 2020-2023 (c) Christian von Arnim, ISW University of Stuttgart (for umati and VDW e.V.)
 * Copyright 2023 (c) Marc Fischer, ISW University of Stuttgart (for umati and VDW e.V.)
 */
import React, { createContext, useEffect, useState } from 'react';
import MQTTSubscription from './mqtt/MQTTSubscription';
import MQTTWebsocket from './mqtt/MQTTWebsocket';

export interface MQTTWebsocketContextValue {
  createSubscription: (
    topic: string,
    subscriptionCallback: (newData: any, topic: string) => void,
  ) => MQTTSubscription | undefined;
}

export const MQTTWebsocketContext = createContext<MQTTWebsocketContextValue | undefined>(undefined);

interface MQTTComponentProps {
  ws: MQTTWebsocket;
}

/**
 * Usage: <MQTTComponent brokerURL="ws://172.21.70.207:80/ws/"><more tags/></MQTTComponent>
 */

export default function MQTTComponent({ ws, children }: React.PropsWithChildren<MQTTComponentProps>) {
  const mqttWebsocket = ws;
  const [mqttHandler, setMqttHandler] = useState<MQTTWebsocketContextValue | undefined>({
    createSubscription: (topic, subscriptionCallback) => {
      return mqttWebsocket?.subscribe(topic, subscriptionCallback);
    },
  });

  useEffect(
    () => () => {
      console.debug('Clear MQTT connection.');
      /// TODO: Require an mqttWebsocket?.mqttClient.end() ?
      setMqttHandler(undefined);
    },
    [],
  );

  return <MQTTWebsocketContext.Provider value={mqttHandler}>{children}</MQTTWebsocketContext.Provider>;
}
